import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import BottomNav from './BottomNav';
import CartSummary from './CartSummary';

interface LayoutProps {
  children: ReactNode;
  currentCategory?: string;
  isCategoryVisible?: boolean;
  onCategoryClick?: () => void;
  logoUrl?: string;
  showRestaurantInfo?: boolean;
  categories?: any[];
  activeCategory?: string;
  onCategoryChange?: (categoryId: string) => void;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  noContainer?: boolean;
}

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  
  /* Fix sticky components on some browsers when using overflow-x: hidden */
  /* Using clip instead of hidden to allow sticky while still preventing horizontal scroll */
  @supports (overflow-x: clip) {
    overflow-x: clip;
  }
  @supports not (overflow-x: clip) {
    overflow-x: hidden;
  }
`;

const Main = styled.main<{ showExtraPadding?: boolean }>`
  flex: 1;
  padding-top: 5rem;

  @media (max-width: 992px) {
    padding-top: ${props => props.showExtraPadding ? '6.2rem' : '4.2rem'};
    /* Espaço para a bottom navigation fixa não cobrir o conteúdo. */
    padding-bottom: calc(64px + env(safe-area-inset-bottom, 0px));
  }
`;

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  currentCategory, 
  isCategoryVisible, 
  onCategoryClick,
  logoUrl,
  showRestaurantInfo = false,
  categories,
  activeCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  noContainer = false
}) => {
  const hasCategories = categories && categories.length > 0;
  const showExtraPadding = showRestaurantInfo && hasCategories;

  return (
    <LayoutContainer>
      <Header 
        currentCategory={currentCategory}
        isCategoryVisible={isCategoryVisible}
        onCategoryClick={onCategoryClick}
        logoUrl={logoUrl}
        showRestaurantInfo={showRestaurantInfo}
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={onCategoryChange}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
      />
      <Main showExtraPadding={showExtraPadding}>
        {noContainer ? (
          children
        ) : (
          <div className="container">
            {children}
          </div>
        )}
      </Main>
      <Footer />
      {/* Carrinho global no mobile: permite abrir a sacola pela BottomNav em
          qualquer página. No desktop, cada página renderiza seu próprio
          CartSummary na barra lateral. */}
      <div className="d-lg-none">
        <CartSummary />
      </div>
      <BottomNav />
    </LayoutContainer>
  );
};

export default Layout;
